import { render, staticRenderFns } from "./DatosTercero.vue?vue&type=template&id=1091e9a8&scoped=true&"
import script from "./DatosTercero.vue?vue&type=script&lang=js&"
export * from "./DatosTercero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1091e9a8",
  null
  
)

export default component.exports